
import { format } from 'date-fns';
import { nl } from 'date-fns/locale';

export const formatTimestamp = (date?: Date): string => {
  if (!date) return "";
  return format(date, 'EEEE d MMMM yyyy HH:mm', { locale: nl });
};

export const sendExternalRequest = async () => {
  try {
    setTimeout(() => {
      // Simulate external request
    }, 1500);
  } catch (error) {
    console.error("External request failed:", error);
  }
};
